module.exports = __webpack_public_path__ + "img/img-ffp-1.fe6bf2e6.jpg";